/**
 * Browser-safe entry point for @coreflow/shared.
 * Exports only types, constants, and pure validation functions.
 * Does NOT export DynamoRepository or any AWS SDK-dependent code.
 */

export * from './events/domain-event.js';
export * from './types/index.js';
export * from './pages-types.js';
export * from './analytics-types.js';
export * from './utils/repository.js';
// Intentionally omit: DynamoRepository, resolve-board-teams-channel (AWS SDK deps)
